import { gql, useQuery } from '@apollo/client';
import useStrapiPageData from './useStrapiPageData';

import {
  // PAGE_CATEGORIES_COMPARE_SYSTEM,
  PAGE_COMPARE_SYSTEM_STATIC,
} from '../../constants/strapi';
import useLocales from './useLocales';

const POPULAR_SYSTEM_COMPARISONS = gql`
  query ($locale: String!) {
    popularSystemComparisons(locale: $locale) {
      allComparisonsSliced {
        systemId
        comparedSystemId
      }
      uniqObjects {
        id
        defaultCategory
        systemSiteDataForLocale(locale: $locale) {
          systemName
          systemNameUrl
          mediaAssets {
            id
            url
            order
            type
            altText
          }
        }
      }
    }
  }
`;

const useGetMostCompared = () => {
  const { locale } = useLocales();
  // const [compareSystemPageUrl] = useStrapiPageData(
  //   PAGE_CATEGORIES_COMPARE_SYSTEM
  // );
  const [compareSystemsStaticPageUrl] = useStrapiPageData(
    PAGE_COMPARE_SYSTEM_STATIC
  );

  const { loading, error, data } = useQuery(POPULAR_SYSTEM_COMPARISONS, {
    variables: { locale },
  });

  const compareData = data?.popularSystemComparisons;
  const { allComparisonsSliced, uniqObjects } = compareData || {};
  const compareArr = allComparisonsSliced?.map((compare) => {
    const systemObj = uniqObjects.find(
      (system) => system.id === compare.systemId
    );

    const compareObj = uniqObjects.find(
      (system) => system.id === compare.comparedSystemId
    );

    // const { defaultCategory } = systemObj;

    if (!systemObj || !systemObj.id || !compareObj || !compareObj.id) {
      return null;
    }

    // const url = `${compareSystemPageUrl}?systems=${
    //   systemObj.systemSiteDataForLocale.systemNameUrl
    // },${
    //   compareObj.systemSiteDataForLocale.systemNameUrl
    // }&category=${defaultCategory.toLowerCase()}`;

    const comparedSystemsObj = [compareObj, systemObj].sort((a, b) =>
      a.id.localeCompare(b.id)
    );

    const systemUrlsForCompare = [];
    comparedSystemsObj.forEach((item) => {
      systemUrlsForCompare.push(item.systemSiteDataForLocale.systemNameUrl);
    });

    const compareStaticUrl = `${compareSystemsStaticPageUrl}${systemUrlsForCompare?.join(
      '-vs-'
    )}/`;

    return {
      id: `${compare.comparedSystemId}-${compare.systemId}`,
      compareUrl: compareStaticUrl,
      systems: [
        {
          id: compareObj.id,
          name: compareObj.systemSiteDataForLocale.systemName,
          logoUrl: `https://ik.imagekit.io/businesswith/tr:w-80,h-40,cm-pad_resize,dpr-2/logo/${
            compareObj?.systemSiteDataForLocale?.mediaAssets?.find(
              (asset) => asset.type === 'LOGO'
            ).url
          }`,
        },
        {
          id: systemObj.id,
          name: systemObj.systemSiteDataForLocale.systemName,
          logoUrl: `https://ik.imagekit.io/businesswith/tr:w-80,h-40,cm-pad_resize,dpr-2/logo/${
            systemObj?.systemSiteDataForLocale?.mediaAssets?.find(
              (asset) => asset.type === 'LOGO'
            ).url
          }`,
        },
      ],
    };
  });

  return { data: compareArr, loading, error };
};

export default useGetMostCompared;
